import React from 'react';

const GoogleAnalytics = () => {
  return (
    <>
      <h5>
        <b>Google Analytics</b>
      </h5>
      <p>
        Google Analytics allows you to measure your advertising ROI as well as track your Flash,
        video, and social networking sites and applications. Also, it’s a great tool for search
        engine optimization (SEO).
      </p>
      <br />
    </>
  );
};

export default GoogleAnalytics;
